import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { CUSTOMER_LOCALES } from '@/i18n/locales';
import { cn } from '@/lib/utils';

/**
 * Selector de idioma solo para menú / checkout / tracking (clientes finales).
 */
export default function CustomerLanguageSwitcher({
  className,
  compact = false,
  style,
  selectStyle,
}) {
  const { i18n, t } = useTranslation();
  const current = String(i18n.language || 'es').slice(0, 2);

  return (
    <label
      className={cn(
        'inline-flex items-center gap-1.5 text-xs text-muted-foreground',
        className,
      )}
      style={style}
      data-testid="customer-language-switcher"
    >
      <Languages className="w-3.5 h-3.5 shrink-0 opacity-80" aria-hidden />
      {!compact ? (
        <span className="sr-only sm:not-sr-only sm:inline">{t('common.language')}</span>
      ) : (
        <span className="sr-only">{t('common.language')}</span>
      )}
      <select
        aria-label={t('common.language')}
        value={CUSTOMER_LOCALES.some((l) => l.code === current) ? current : 'es'}
        onChange={(e) => {
          const next = e.target.value;
          void i18n.changeLanguage(next);
        }}
        className={cn(
          'h-8 max-w-[9.5rem] rounded-md border border-border/70 bg-background/90 px-2 text-xs font-medium text-foreground',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        )}
        style={selectStyle}
      >
        {CUSTOMER_LOCALES.map((locale) => (
          <option key={locale.code} value={locale.code}>
            {locale.nativeLabel}
          </option>
        ))}
      </select>
    </label>
  );
}
